import { Component, inject, OnInit } from '@angular/core';
import { ButtonsComponent } from 'gung-standard';
import { ColmecCheckoutWrapperComponent } from '../colmec-checkout-wrapper/colmec-checkout-wrapper.component';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'colmec-buttons',
    templateUrl: './colmec-buttons.component.html',
    styleUrls: ['./colmec-buttons.component.scss'],
    standalone: false
})
export class ColmecButtonsComponent extends ButtonsComponent implements OnInit {
  private checkoutWrapper = inject(ColmecCheckoutWrapperComponent);

  public isDisabled: boolean;
  public isDisabledByAvailability: boolean;
  public isLastStep = false;
  public isView = undefined;

  ngOnInit(): void {
    this.authService.getRoles().subscribe(roles => {
      this.isView = roles.indexOf('VIEW') > -1;
      this.isDisabled = this.isView;
    });

    this.navbarCartService
      .getContents()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(contents => {
        this.isDisabledByAvailability = contents.rows.some(
          row => row.cartRow.qty > row.product.extra?.availability?.currentAvailability
        )
      })

    super.ngOnInit();
  }

  updateData() {
    this.isFirstStep = this.allSteps.indexOf(this.currentStep) === 0;
    this.isLastStep = this.allSteps.indexOf(this.currentStep) === this.allSteps.length - 1;
  }

  createQuotation(): void {
    this.checkoutWrapper.quotationCheckoutObject();
  }
}
